



































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Applicant, ApplicantData } from "../types";
import { required, email } from "vuelidate/lib/validators";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { User } from "@/modules/auth/types";
import AuditLogTable from "./ApplicantAuditLogTable.vue";
import Loader from "../../externals/components/Loader.vue";
const Applicants = namespace("applicant");

const Auth = namespace("auth");

@Component({
  components: {
    DatePicker,
    loader: Loader,
    "all-applicant-audit-table": AuditLogTable,
  }
})
export default class DataPoints extends Vue {
  showReadOnlyDatapoint = true;
  showAuditLogOnlyDatapoint = false;

  @Auth.Getter("getUser") user!: User;


  auditLogText() {
    return this.showAuditLogOnlyDatapoint ? 'Back to Applicant' : 'View Audit Log';
  }


  isAdmin(allowDevelopers) {
    // 0 = Admin, 1 = Developer

    if (allowDevelopers) return this.user.role === 0 || this.user.role === 1 || this.user.role === 3;
    else return this.user.role === 0 || this.user.role === 3;
  }

  @Applicants.Getter("currentApplicant") applicant: Applicant;
  @Applicants.Action("updateApplicant") updateApplicant!: (
    payload: ApplicantData,
  ) => Promise<void>;
  @Applicants.Action("fetchCurrentApplicant") fetchCurrentApplicant!: (
    applicantId: string
  ) => Promise<{}>;


  formattedDate(dateString: string) {
    const date = new Date(dateString);
    const month = date.getMonth() + 1; //the month is 0 indexed
    const formattedMonth = month < 10 ? "0" + month : month;
    const formattedDay =
      date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    return date.getFullYear() + "-" + formattedMonth + "-" + formattedDay;
  }

  loading = false;
  updateForm = {
    firstName: "",
    lastName: "",
    dob: "",
    sex: "",
    addressOne: "",
    addressTwo: "",
    dateIssued: "",
    expirationDate: "",
    nationality: "",
  };

  @Watch('applicant', { immediate: true, deep: true })
  onApplicantChange(newVal: Applicant) {

    if (newVal && newVal.idDocumentData) {
      this.updateForm = {
        firstName: newVal.idDocumentData.firstName || "",
        lastName: newVal.idDocumentData.lastName || "",
        dob: newVal.idDocumentData.dateOfBirth || "",
        sex: newVal.idDocumentData.sex || "",
        addressOne: newVal.idDocumentData.address1 || "",
        addressTwo: newVal.idDocumentData.address2 || "",
        dateIssued: newVal.idDocumentData.issueDate || "",
        expirationDate: newVal.idDocumentData.expirationDate || "",
        nationality: newVal.idDocumentData.nationality || "",
      };
    }
  }

  async submitForm() {
    try {

      this.loading = true;
      const applicantId = this.applicant?.id?.toString() ?? '';
      const applicantData = { ...this.updateForm };
      const {
        firstName,
        lastName,
        dob,
        sex,
        addressOne,
        addressTwo,
        dateIssued,
        nationality,
        expirationDate,
      } = applicantData;
      // Call the updateApplicant action with the applicant ID and updated data

      await this.updateApplicant({
        applicantId,
        firstName,
        lastName,
        sex,
        dob,
        addressOne,
        addressTwo,
        dateIssued,
        nationality,
        middleName: this.applicant.middleName,
        email: this.applicant.email,
        expirationDate,
      });
      // Optionally, handle any success actions (e.g., navigation)
      await this.fetchCurrentApplicant(applicantId);
      this.$notify({
        group: "success",
        title: "Important message",
        text: "Applicant updated",
      });
    } catch (error) {
      // Optionally, handle any error or display error messages
      
      this.$notify({
        group: "error",
        title: "Error",
        text: "An error occurred",
      });
    } finally {
      this.loading = false;
    }
  }

  validations() {
    return {
      updateForm: {
        firstName: {
          required,
        },
        lastName: {
          required,
        },
        dob: {
          required,
        },
        sex: {

        },
        addressOne: {
          required
        },
        addressTwo: {
          required
        },
        dateIssued: {
          required
        },
        expirationDate: {
          required
        },
        nationality: {

        }
      }
    };
  }

  formattedDatePicker(dateString: string) {
    const date = new Date(dateString);
    const formattedMonth = ('0' + (date.getMonth() + 1)).slice(-2);
    const formattedDay = ('0' + date.getDate()).slice(-2);
    const formattedDate = `${date.getFullYear()}-${formattedMonth}-${formattedDay}`;
    return formattedDate;
  }

  hideReadonlyDataPointContainer(e) {
    e.preventDefault();
    this.showAuditLogOnlyDatapoint = false;
    if (this.showReadOnlyDatapoint) {

      this.showReadOnlyDatapoint = false;
    }
    else {
      this.showReadOnlyDatapoint = true;
    }

  }

  hideShowAuditLog(e) {
    e.preventDefault();
    if (this.showAuditLogOnlyDatapoint) {

      this.showAuditLogOnlyDatapoint = false;
    }
    else {
      this.showAuditLogOnlyDatapoint = true;
    }

  }
}

